<template>
  <div>
    <BaseTitle :title="$t('content.bank_soal_ic')" />
    <v-card class="pa-5 mb-7">
      <v-progress-circular class="text-center" v-if="loadingButton === true" indeterminate color="primary"></v-progress-circular>
      <h3>{{ $t('filter') }}</h3>
      <v-row>
        <!-- <v-col cols="12" md="4">
          <v-select v-model="form.cerdasTypeId" clearable :items="lockItems" :label="`${$t('content.cerdas_type')} `" @change="getData" />
        </v-col> -->
        <v-col cols="12" md="6">
          <v-text-field
            v-model="form.gradeId"
            :label="$t('content.class_level')"
            clearable
            append-outer-icon="mdi-send"
            @click:append-outer="getData"
            @keyup.enter="getData"
            @change="getData"
          />
          <!-- <v-select
            v-model="form.gradeId"
            item-value="gradeId"
            item-text="gradeName"
            clearable
            :items="classLevel"
            :label="$t('content.class_level')"
            @change="getData"
          /> -->
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field
            v-model="form.courseId"
            :label="$t('menu.course')"
            @keyup.enter="getData"
            append-outer-icon="mdi-send"
            @click:append-outer="getData"
            clearable
            @change="getData"
          />
          <!-- <v-select
            v-model="form.courseId"
            item-value="courseId"
            item-text="name"
            clearable
            :items="course"
            @change="getData"
            :label="$t('menu.course')"
          /> -->
        </v-col>
        <!-- <v-col cols="12" md="3">
          <v-select
            v-model="form.educationalLevel"
            item-value="educationalLevel"
            item-text="educationalLevel"
            clearable
            :items="educationList"
            @change="getData"
            :loading="loadingEducation"
            :label="$t('content.education_level')"
          />
        </v-col> -->
      </v-row>
    </v-card>
    <v-card>
      <div>
        <div class="pa-5 d-flex justiy-space-between align-items section-header active">
          <div class="student-title">{{ $t('content.bank_soal_ic') }}</div>
        </div>
        <div class="ml-5 mt-3 mr-5">
          <div class="d-flex align-center justify-space-between">
            <div>
              <v-text-field v-model="form.search" :label="$t('search')" @change="getData">
                <template #prepend-inner>
                  <svg-icon icon="ic-search" class="primary--text mr-3" />
                </template>
              </v-text-field>
            </div>
          </div>
        </div>

        <div v-if="loadingLoad === true" class="text-center pb-2">
          <v-progress-circular indeterminate color="primary" />
        </div>
        <div class="border-item" v-for="item in datas" :key="item.syllabusId">
          <v-row class="border-item">
            <v-col md="1" align="center">
              <div class="mt-5 ml-5">
                <svg-icon icon="bank-soal" width="30" height="30" class="primary--text" />
                <v-divider vertical></v-divider>
              </div>
            </v-col>
            <v-col md="9" class="mt-3">
              <div class="d-block">
                <h3 class="d-inline">
                  <span class="header-content">{{ item.quizTitle }} </span>
                </h3>
              </div>
              <div class="d-block">
                <div>
                  <span class="body-content">
                    <!-- <span class="mr-3">
                      {{ $t('content.cerdas_type') }}:
                      <strong v-if="item.cerdasTypeId === 2" style="color :#6DD400;">Pro</strong>
                      <strong v-if="item.cerdasTypeId === 1" style="color :#B30FFF;">Lite</strong>
                    </span>
                    |
                    <span class="mr-3">
                      {{ $t('form.school_name') }}:
                      <strong v-if="item.schoolName" style="color :#56A6DC;">{{ item.schoolName }}</strong>
                    </span> -->
                    <!-- | -->
                    <span class="mr-3">
                      {{ $t('roles.teacher') }} :
                      <strong>{{ item.teacherName }}</strong>
                    </span>
                    |
                    <span class="mr-3">
                      {{ $t('table.grade') }} :
                      <strong>{{ item.gradeName }}</strong>
                    </span>
                    |
                    <span class="mr-3">
                      {{ $t('menu.course') }} : <strong>{{ item.courseName }}</strong>
                    </span>
                    <!-- |
                    <span class="mr-3">
                      {{ $t('content.education_level') }} :
                      <strong>{{ item.educationalLevel }}</strong>
                    </span> -->
                  </span>
                </div>
              </div>
              <div class="d-flex"></div>
            </v-col>
            <v-col md="1">
              <v-btn color="primary" :disabled="item.imported === true" class="btn-primary-custom mt-5" @click="importSoalPopUp(item.quizId)">{{
                $t('content.import')
              }}</v-btn>
            </v-col>
            <v-col md="1">
              <template>
                <div class="pa-5">
                  <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <span dark v-bind="attrs" v-on="on">
                        <svg-icon icon="ic-moreaction-black" class="mt-1" />
                      </span>
                    </template>
                    <v-list>
                      <v-list-item>
                        <v-list-item-title class="text-dropdown" @click="goView(item.quizId)">{{ $t('view') }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </div>
              </template>
            </v-col>
          </v-row>
        </div>
        <NoData v-if="!datas.length && !loadingLoad" />
      </div>
    </v-card>
    <!-- Dialog Import -->
    <v-dialog v-model="dialogPopUp" persistent max-width="607">
      <v-card>
        <v-card-title class="headline secondary white--text">
          {{ $t('content.import') }}
        </v-card-title>
        <v-card-subtitle class="headline d-flex justify-center pa-5">
          <v-row>
            <v-col cols="12" md="6">
              <form-group :name="$t('content.class_level')" no-gutter :validator="$v.formImport.gradeId">
                <template slot-scope="{ attrs }">
                  <v-select
                    v-bind="attrs"
                    v-model="formImport.gradeId"
                    item-value="gradeId"
                    item-text="gradeName"
                    clearable
                    :items="classLevel"
                    :label="$t('content.class_level')"
                    @change="getCourse"
                    @input="$v.formImport.gradeId.$touch()"
                    @blur="$v.formImport.gradeId.$touch()"
                  />
                </template>
              </form-group>
            </v-col>
            <v-col cols="12" md="6">
              <form-group :name="$t('menu.course')" no-gutter :validator="$v.formImport.courseId">
                <template slot-scope="{ attrs }">
                  <v-select
                    v-bind="attrs"
                    v-model="formImport.courseId"
                    item-value="courseId"
                    item-text="name"
                    clearable
                    :items="course"
                    @input="$v.formImport.courseId.$touch()"
                    @blur="$v.formImport.courseId.$touch()"
                    :label="$t('menu.course')"
                  />
                </template>
              </form-group>
            </v-col>
          </v-row>
        </v-card-subtitle>
        <v-card-actions>
          <v-spacer />
          <div class="d-flex justify-end align-center">
            <v-btn color="primary" class="btn-primary-custom mr-3" outlined @click="closePopup">{{ $t('back') }}</v-btn>
            <v-btn color="primary" class="btn-primary-custom" :loading="loadingImport" type="submit" @click="importSoal">{{ $t('submit') }}</v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTitle from '@/components/base/Title';
import NoData from '@/components/table/NoData';
import { required } from 'vuelidate/lib/validators';

export default {
  name: 'BankSoalIndex',
  components: {
    BaseTitle,
    NoData
  },
  props: {
    isClass: {
      type: Boolean,
      default: false
    },
    isStudent: {
      type: Boolean,
      default: false
    }
  },
  validations: {
    formImport: {
      courseId: { required },
      gradeId: { required }
    }
  },
  computed: {
    ...mapGetters({
      course: 'QuizTeacher/courses',
      classLevel: 'QuizTeacher/classLevel',
      permission: 'Auth/permission',
      user: 'Auth/user',
      nameCourse: 'CourseList/nameCourse'
    }),
    lockItems() {
      return [
        { text: 'Lite', value: 1 },
        { text: 'Pro', value: 2 }
      ];
    }
  },
  data: () => ({
    loadingButton: false,
    dialogDelete: false,
    dialogPopUp: false,
    loadingLoad: false,
    loadingImport: false,
    imported: false,
    form: {
      search: '',
      cerdasTypeId: '',
      courseId: '',
      gradeId: '',
      educationalLevel: ''
    },
    formImport: {
      courseId: '',
      gradeId: '',
      quizId: ''
    },
    datas: [],
    loadingEducation: false,
    educationList: []
  }),
  methods: {
    getData() {
      this.loadingLoad = true;
      this.$store
        .dispatch('BankSoal/fetchList', { ...this.form })
        .then(res => (this.datas = res))
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
        .finally(() => (this.loadingLoad = false));
    },
    getEducation() {
      this.loadingEducation = true;
      this.$store
        .dispatch('School/getEducationList')
        .then(res => (this.educationList = res))
        .finally(() => {
          this.loadingEducation = false;
        });
    },
    goView(id) {
      this.$router.push({ name: 'BankSoalView', params: { id } });
    },
    getClassLevel() {
      this.$store.dispatch('QuizTeacher/fetchClassLevelOrCourse');
    },
    getCourse() {
      this.$store.dispatch('QuizTeacher/fetchClassLevelOrCourse', this.formImport.gradeId);
      this.getData();
    },
    importSoal() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return false;
      }
      this.loadingImport = true;

      this.$store
        .dispatch('BankSoal/import', { ...this.formImport })
        .then(() => this.getData())
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
        .finally(() => {
          this.$store.dispatch('general/showSuccessNotification', { message: 'Success Import' });
          this.loadingImport = false;
          this.courseId = '';
          this.gradeId = '';
          this.quizId = '';
          this.dialogPopUp = false;
        });
    },
    importSoalPopUp(item) {
      this.formImport.quizId = item;
      this.dialogPopUp = true;
    },
    closePopup() {
      this.courseId = '';
      this.gradeId = '';
      this.quizId = '';
      this.dialogPopUp = false;
    }
  },
  created() {
    this.getData();
    this.getClassLevel();
    // this.getEducation();
  }
};
</script>

<style lang="scss" scoped>
.assigment-icon {
  width: 30px;
  height: 30px;
}

.border-item {
  border-bottom: 1px solid #dedede;
}
.text-dropdown {
  cursor: pointer;
  &-delete {
    color: red;
    cursor: pointer;
  }
}

.header-content {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 14px;
  line-height: 16px;
  width: 133px;
  text-align: left;
}

.body-content {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 12px;
  line-height: 14px;
  text-align: left;
}

.section-header {
  border-radius: 4px 4px 0 0;

  &.active {
    background: #00bf63;
    .student-title {
      color: #fff;
      font-size: 18px;
      font-weight: bold;
    }
  }

  &.disabled {
    background: #acacac;
    pointer-events: none;

    .student-title {
      color: #fff;
    }
  }
}
.pb-2 {
  padding-bottom: 1.5rem !important;
}
</style>
